// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoSlide_videoContainer__zKMOF","videoContainer__videoIcon":"VideoSlide_videoContainer__videoIcon__m5o8-"};